<div class="flex items-center justify-between mt--4">
  <div class="flex items-center">
    <mat-icon svgIcon="settings_backup_restore" class="mr-8"></mat-icon>
    <div class="mat-subtitle-2 mb-0 fs-24 fw-600">{{'UPDATE_MANAGER.UPDATE_MANAGER' | transloco}}
      <span>({{searchTerm?.length > 0 && searchedResult ? searchedResult.length || 0 : (data?.length || 0)}})</span>
    </div>
    <div [ngClass]="{'filter-disabled': !componentsResponse || componentsLoading || components?.length === 0}"
      class="ml-16 search-component">
      <app-search-filter class="mt-20 ml-20" placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
    </div>
    <span class="vertical-dash ml-12"></span>
    <button
      class="flex justify-center items-center context-menu-icon-filter height menu-btn pr-8 pl-8 pt-6 pb-6 ml-12 filter disabled">
      <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
      <span class="fw-500 filters">{{'TENANT_LIST.FILTERS' | transloco}}</span>
    </button>
  </div>
  @if (components?.length > 0) {
  <div class="flex flex-row gap-3 create-runbook">
    @if (selectedData && componentsResponse && !showLoader) {
    <button type="submit" class="flex accent h-32 fw-700 place-items-center mt-16 mr-8"
    [ngClass]="{'disable-update': disableUpdate}"
      (click)="disableUpdate ? null : onUpdateClick()"
      [matTooltip]="(disableUpdate? 'UPDATE_MANAGER.UPDATE_NOT_ALLOWED' : '') | transloco"
      matTooltipClass="form-tooltip above" matTooltipPosition="{{Constants.POSITION_ABOVE}}">
      {{ 'BUTTONS.UPDATE' | transloco }}
    </button>
    }
    <div class="refresh-circle rounded-full w-32 h-32 flex items-center justify-center cursor-pointer"
      (click)="refreshClick()">
      <mat-icon svgIcon="refresh" class="icons transition-transform duration-700"
        [ngClass]="{ 'animate-spin': isRefreshing }"></mat-icon>
    </div>
    <app-environment-paginator [length]="searchedResult?.length" [pageIndex]="pageIndex" [pageSize]="paginationSize"
      (page)="onPageChange($event)"></app-environment-paginator>
  </div>
  }
</div>
<mat-divider class="neutral-2 mt-12 mb-12 ml-4 mr-4"></mat-divider>
@if (componentsResponse && !showLoader) {
<div class="flex flex-col border-radius route-table envt-schedule mb-16 mt-8">
  <app-environment-table class="runbook-table" (approve)="getApproveData($event)" [ngClass]="{'disabled': showLoader}"
    (searchedResults)="searchedItems($event)" [displayColumns]="displayColumns" [showSkeletonLoader]="componentsLoading"
    [initialDataSource]="data" [dataLoading]="componentsLoading" [searchTerm]="searchTerm" [dataSourceLength]="true"
    [initialCreate]="components?.length === 0" (pageChanged)="onPageChange($event)" (sorted)="resetPaginator()"
    (pageModify)="onTablePageChanged($event)"
    pageName="environmentUpdateManager"></app-environment-table>
</div>
}
@if(!componentsResponse && !apiNotFound && !showLoader && !components?.length) {
<div class="flex flex-col">
  <div class="flex flex-col empty-panel ml-10 mr-16 mt-16">
    <div class="empty-data flex flex-col items-center mt-32 ">
      <img class="w-106" alt="components not found" src="/assets/images/service_not_found.png">
      <div class="flex mt-6 ">{{'UPDATE_MANAGER.NO_COMPONENTS' | transloco }}</div>
    </div>
  </div>
</div>
}
@if (showLoader && componentsLoading) {
<div class="loader-section">
  <div class="runbook-group loader-header flex flex-col p-16">
    <div class="flex flex-row">
      @for (tableColumn of displayColumns; track tableColumn?.key) {
      <div class="loader-style">
        <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
      </div>
      }
    </div>
  </div>

  @for (item of [1, 2, 3]; track $index) {
  <div class="w-100-percent">
    <div class="runbook-group flex flex-col p-16">
      <div class="flex flex-row">
        @for (tableColumn of displayColumns; track tableColumn?.key) {
        <div class="loader-style">
          <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
        </div>
        }
      </div>
    </div>
  </div>
  }
</div>
}